<!-- <div class="tab-content">
      <div class="tab-content-row">
        <div class="recent-device-events general-table-holder">
          <h2 class="general-table-titles">Recent Device Events</h2>
          @if(RecentDeviceEventsData!==undefined){

          <table class="general-table">
            <tr>
              @for(header of RecentDeviceEventsData.headers;track header){
              <th>{{header}}</th>
              }
            </tr>

            @for (row of RecentDeviceEventsData.rows; track row) {
            <tr>
              @for(data of row; track data){
              @if(isString(data)){
              <td>{{data}}</td>
              }@else {
              <td>
                <mat-icon class="icons">{{data.icon}}</mat-icon>
              </td>
              }
              }
            </tr>
            }
          </table>
          }@else {
          <div class="no-logs-warning">
            <mat-icon class="icons warning-icon">warning</mat-icon>
            <span class="warning-message">No logs were found</span>
          </div>

          }
        </div>
        <div class="recent-device-files general-table-holder">
          <h2 class="general-table-titles">Recent Device Files</h2>
          @if(RecentDeviceFilesData!==undefined){

          <table class="general-table">
            <tr>
              @for(header of RecentDeviceFilesData.headers;track header){
              <th>{{header}}</th>
              }
            </tr>

            @for (row of RecentDeviceFilesData.rows; track row) {
            <tr>
              @for(data of row; track data){
              @if(isString(data)){
              <td>{{data}}</td>
              }@else {
              <td>
                <mat-icon class="icons">{{data.icon}}</mat-icon>
              </td>
              }
              }
            </tr>
            }
          </table>
          }@else {
          <div class="no-logs-warning">
            <mat-icon class="icons warning-icon">warning</mat-icon>
            <span class="warning-message">No logs were found</span>
          </div>
          }

        </div>
      </div>
      <div class="tab-content-row">
        <div class="recent-task-manager-logs general-table-holder">
          <h2 class="general-table-titles">Recent Task Manager Logs</h2>
          @if(RecentTaskManagerLogsData!==undefined){

          <table class="general-table">
            <tr>
              @for(header of RecentTaskManagerLogsData.headers;track header){
              <th>{{header}}</th>
              }
            </tr>

            @for (row of RecentTaskManagerLogsData.rows; track row) {
            <tr>
              @for(data of row; track data){
              @if(isString(data)){
              <td>{{data}}</td>
              }@else {
              <td>
                <mat-icon class="icons">{{data.icon}}</mat-icon>
              </td>
              }
              }
            </tr>
            }
          </table>
          }@else {
          <div class="no-logs-warning">
            <mat-icon class="icons warning-icon">warning</mat-icon>
            <span class="warning-message">No logs were found</span>
          </div>
          }
        </div>
        <div class="configuration-logs general-table-holder">
          <h2 class="general-table-titles">Configuration Logs</h2>
          @if(ConfigurationLogsData!==undefined){

          <table class="general-table">
            <tr>
              @for(header of ConfigurationLogsData.headers;track header){
              <th>{{header}}</th>
              }
            </tr>

            @for (row of ConfigurationLogsData.rows; track row) {
            <tr>
              @for(data of row; track data){
              @if(isString(data)){
              <td>{{data}}</td>
              }@else {
              <td>
                <mat-icon class="icons">{{data.icon}}</mat-icon>
              </td>
              }
              }
            </tr>
            }
          </table>
          }@else {
          <div class="no-logs-warning">
            <mat-icon class="icons warning-icon">warning</mat-icon>
            <span class="warning-message">No logs were found</span>
          </div>
          }
        </div>
      </div>
    </div> -->

@if (!loading) {
@for (table of dataTables; track table;let i=$index;let last=$last;)
{

@if (i%2===0){
<div class="container" [ngClass]="(!last && dataTables[i + 1])?'split':'one'">
  <div class="log-container">
    @if (table.loading){
      <div class="loading-container">
        <mat-spinner></mat-spinner>
      </div>
    } @else{
    <div class="table-header">
      <h3>{{table.heading}}</h3>
      <div>
        @for (btn of table.buttons;track btn) {
          <button mat-icon-button (click)="btn.action()" class="close-button">
            <mat-icon>{{btn.icon}}</mat-icon>
          </button>
        }
      </div>
    </div>

    <table class="general-table">
      <tr>
        @for (header of table.columns;track header) {
        <th>{{header.header}}</th>
        }
      </tr>

      @for (row of table.rows; track row) {
      <tr>
        @for (header of table.columns;track header) {
        <td [ngClass]="header.class??''"
          [style]="header.styles ?((header.styles.unclickable??'')+(header.styles.all??'')):''">{{row[header.rowKey]}}
        </td>
        }
      </tr>
      }
    </table>
    }
  </div>
  @if(!last && dataTables[i + 1]){
  <div class="log-container">
    @if(dataTables[i+1].loading){
      <div class="loading-container">
        <mat-spinner></mat-spinner>
      </div>
    }@else{
    <div class="table-header">
      <h3>{{dataTables[i + 1].heading}}</h3>
      <div>
        @for (btn of dataTables[i + 1].buttons;track btn) {
        <button mat-icon-button (click)="btn.action()" class="close-button">
          <mat-icon>{{btn.icon}}</mat-icon>
        </button>
        }

      </div>
    </div>

    <table class="general-table">
      <tr>
        @for (header of dataTables[i + 1].columns;track header) {
        <th>{{header.header}}</th>
        }
      </tr>

      @for (row of dataTables[i + 1].rows; track row) {
      <tr>
        @for (header of dataTables[i + 1].columns;track header) {
        <td [ngClass]="header.class??''"
          [style]="header.styles ?((header.styles.unclickable??'')+(header.styles.all??'')):''">{{row[header.rowKey]}}
        </td>
        }
      </tr>
      }
    </table>
    }
  </div>
  }
</div>

}
}
} @else {
<div class="loading-container">
  <mat-spinner></mat-spinner>
</div>
}
<!-- <div class="container" [ngClass]="(RecentDeviceEventsData!=null && RecentDeviceFilesData!=null)?'split':'one'">
  @if(RecentDeviceEventsData==null && RecentDeviceFilesData==null && RecentTaskManagerLogsData==null &&
  ConfigurationLogsData==null){
  <div class="no-logs-warning">
    <span class="warning-message">No logs were found</span>
  </div>
  }

  @if (RecentDeviceEventsData != null) {
  <div class="log-container">
    @if (!recentDeviceEventsLoading) {
    <div class="table-header">
      <h3>Recent Device Events</h3>
      <button mat-icon-button (click)="displayFullTable(recentDeviceEventsActionTypes)" class="close-button">
        <mat-icon>fullscreen</mat-icon>
      </button>
    </div>

    <table class="general-table">
      <tr>
        @for (header of RecentDeviceEventsData.headers;track header) {
        <th>{{header}}</th>
        }
      </tr>

      @for (row of RecentDeviceEventsData.rows; track row) {
      <tr>
        <td>{{row["Description"]}}</td>
        <td>{{row["User"]}}</td>
        <td>{{row["Type"]}}</td>
        <td>{{row["Timestamp"]}}</td>
      </tr>
      }
    </table>
    } @else {
    <div class="loading-container">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>
    }
  </div>
  }
  @if (RecentDeviceFilesData != null) {
  <div class="log-container">
    @if (!recentDeviceFilesLoading) {
    <div class="table-header">
      <h3>Recent Device Files</h3>
      <button mat-icon-button (click)="displayFullTable(recentDeviceFilesActionTypes)" class="close-button">
        <mat-icon>fullscreen</mat-icon>
      </button>
    </div>
    <table class="general-table">
      <tr>
        @for (header of RecentDeviceFilesData.headers;track header) {
        <th>{{header}}</th>
        }
      </tr>

      @for (row of RecentDeviceFilesData.rows; track row) {
      <tr>
        <td>{{row["Description"]}}</td>
        <td>{{row["User"]}}</td>
        <td>{{row["Type"]}}</td>
        <td>{{row["Timestamp"]}}</td>
      </tr>
      }
    </table>
    } @else {
    <div class="loading-container">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>
    }
  </div>
  }
</div>
<div class="container" [ngClass]="(RecentDeviceEventsData!=null && RecentDeviceFilesData!=null)?'split':'one'">
  @if (RecentTaskManagerLogsData != null) {
  <div class="log-container">
    <div class="table-header">
      <h3>Recent Task Manager Logs</h3>
      <button mat-icon-button class="close-button">
        <mat-icon>fullscreen</mat-icon>
      </button>
    </div>
  </div>
  }
  @if (ConfigurationLogsData != null) {
  <div class="log-container">
    <div class="table-header">
      <h3>Configuration Logs</h3>
      <button mat-icon-button class="close-button">
        <mat-icon>fullscreen</mat-icon>
      </button>
    </div>
  </div>
  }
</div>
} @else {
<div class="loading-container">
  <mat-spinner></mat-spinner>
</div>
} -->